import { render, staticRenderFns } from "./CostCenterIntro.vue?vue&type=template&id=68d50246&scoped=true"
import script from "./CostCenterIntro.vue?vue&type=script&lang=js"
export * from "./CostCenterIntro.vue?vue&type=script&lang=js"
import style0 from "./CostCenterIntro.vue?vue&type=style&index=0&id=68d50246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d50246",
  null
  
)

export default component.exports